<template>
  <div class="dict-management">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>字典管理</span>
          <el-button type="primary" @click="handleAddDict">添加字典</el-button>
        </div>
      </template>

      <!-- 字典列表 -->
      <el-table :data="dicts" v-loading="loading" border style="width: 100%">
        <el-table-column prop="code" label="字典编码" width="150"></el-table-column>
        <el-table-column prop="name" label="字典名称" width="150"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="handleViewItems(scope.row)">字典</el-button>
            <el-button type="primary" size="small" @click="handleEditDict(scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="handleDeleteDict(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 字典对话框 -->
    <el-dialog
      :title="dictDialogTitle"
      v-model="dictDialogVisible"
      width="500px"
    >
      <el-form :model="dictForm" :rules="dictRules" ref="dictForm" label-width="100px">
        <el-form-item label="字典编码" prop="code">
          <el-input v-model="dictForm.code" :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item label="字典名称" prop="name">
          <el-input v-model="dictForm.name"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" v-model="dictForm.description"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dictDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitDictForm">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 字典项对话框 -->
    <el-dialog
      :title="itemDialogTitle"
      v-model="itemDialogVisible"
      width="800px"
    >
      <el-form :model="itemForm" :rules="itemRules" ref="itemForm" label-width="100px">
        <el-form-item label="编码" prop="code">
          <el-input v-model="itemForm.code" :disabled="isEdit"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="itemForm.name"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" v-model="itemForm.description"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort_order">
          <el-input-number v-model="itemForm.sort_order" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="额外信息" prop="extra_info">
          <el-input
            type="textarea"
            v-model="itemForm.extra_info"
            :rows="6"
            placeholder="请输入JSON格式的额外信息，例如：&#10;{&#10;  &quot;website&quot;: &quot;https://example.com&quot;,&#10;  &quot;address&quot;: &quot;123 Street&quot;,&#10;  &quot;phone&quot;: &quot;123456789&quot;,&#10;  &quot;email&quot;: &quot;example@example.com&quot;&#10;}"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="itemDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitItemForm">确定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 字典项列表对话框 -->
    <el-dialog
      :title="currentDict ? `${currentDict.name} - 字典项管理` : '字典项管理'"
      v-model="itemsDialogVisible"
      width="1000px"
    >
      <div class="dict-items-header">
        <el-button type="primary" @click="handleAddItem">添加字典项</el-button>
      </div>

      <el-table :data="dictItems" v-loading="itemsLoading" border style="width: 100%">
        <el-table-column prop="code" label="编码" width="120"></el-table-column>
        <el-table-column prop="name" label="名称" width="120"></el-table-column>
        <el-table-column prop="description" label="描述" width="200"></el-table-column>
        <el-table-column prop="sort_order" label="排序" width="80"></el-table-column>
        <el-table-column label="额外信息" min-width="200">
          <template #default="scope">
            <el-button type="text" @click="showExtraInfo(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="handleEditItem(scope.row)">编辑</el-button>
            <el-button type="danger" size="small" @click="handleDeleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 额外信息对话框 -->
    <el-dialog
      title="额外信息详情"
      v-model="extraInfoDialogVisible"
      width="600px"
    >
      <div v-if="currentExtraInfo">
        <div v-for="(value, key) in currentExtraInfo" :key="key" class="extra-info-item">
          <span class="extra-info-label">{{ formatExtraInfoKey(key) }}:</span>
          <span class="extra-info-value">{{ value }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DictManagement',
  data() {
    return {
      loading: false,
      itemsLoading: false,
      dicts: [],
      dictItems: [],
      currentDict: null,
      
      // 字典对话框
      dictDialogVisible: false,
      dictDialogTitle: '',
      dictForm: {
        code: '',
        name: '',
        description: ''
      },
      dictRules: {
        code: [
          { required: true, message: '请输入字典编码', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入字典名称', trigger: 'blur' }
        ]
      },
      
      // 字典项对话框
      itemDialogVisible: false,
      itemDialogTitle: '',
      itemForm: {
        code: '',
        name: '',
        description: '',
        sort_order: 0,
        extra_info: ''
      },
      itemRules: {
        code: [
          { required: true, message: '请输入编码', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        sort_order: [
          { required: true, message: '请输入排序号', trigger: 'blur' }
        ],
        extra_info: [
          { validator: this.validateJson, trigger: 'blur' }
        ]
      },

      // 字典项列表对话框
      itemsDialogVisible: false,

      // 额外信息对话框
      extraInfoDialogVisible: false,
      currentExtraInfo: null
    }
  },
  created() {
    this.fetchDicts()
  },
  methods: {
    // 验证JSON格式
    validateJson(rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      try {
        JSON.parse(value)
        callback()
      } catch (error) {
        callback(new Error('请输入有效的JSON格式'))
      }
    },

    // 显示额外信息
    showExtraInfo(row) {
      try {
        this.currentExtraInfo = JSON.parse(row.extra_info)
        this.extraInfoDialogVisible = true
      } catch (error) {
        this.$message.error('额外信息格式错误')
      }
    },

    // 格式化额外信息键名
    formatExtraInfoKey(key) {
      const keyMap = {
        website: '网站',
        address: '地址',
        phone: '电话',
        email: '邮箱'
      }
      return keyMap[key] || key
    },

    // 获取字典列表
    async fetchDicts() {
      this.loading = true
      try {
        const response = await axios.get('https://aidata.haimoney.com.au/api/dict.php')
        this.dicts = response.data
      } catch (error) {
        this.$message.error('获取字典列表失败')
        console.error(error)
      }
      this.loading = false
    },

    // 获取字典项列表
    async fetchDictItems(dictCode) {
      this.itemsLoading = true
      try {
        const response = await axios.get(`https://aidata.haimoney.com.au/api/dict_item.php?dict_code=${dictCode}`)
        this.dictItems = response.data
      } catch (error) {
        this.$message.error('获取字典项列表失败')
        console.error(error)
      }
      this.itemsLoading = false
    },

    // 查看字典项
    async handleViewItems(row) {
      this.currentDict = row
      this.itemsDialogVisible = true
      await this.fetchDictItems(row.code)
    },

    // 添加字典
    handleAddDict() {
      this.dictDialogTitle = '添加字典'
      this.dictForm = {
        code: '',
        name: '',
        description: ''
      }
      this.dictDialogVisible = true
    },

    // 编辑字典
    handleEditDict(row) {
      this.dictDialogTitle = '编辑字典'
      this.dictForm = { ...row }
      this.dictDialogVisible = true
    },

    // 删除字典
    async handleDeleteDict(row) {
      try {
        await this.$confirm('确认删除该字典吗？删除后将无法恢复。', '提示', {
          type: 'warning'
        })
        await axios.delete(`https://aidata.haimoney.com.au/api/dict.php?id=${row.id}`)
        this.$message.success('删除成功')
        this.fetchDicts()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败')
          console.error(error)
        }
      }
    },

    // 提交字典表单
    async submitDictForm() {
      try {
        await this.$refs.dictForm.validate()
        if (this.dictForm.id) {
          await axios.put('https://aidata.haimoney.com.au/api/dict.php', this.dictForm)
        } else {
          await axios.post('https://aidata.haimoney.com.au/api/dict.php', this.dictForm)
        }
        this.$message.success('保存成功')
        this.dictDialogVisible = false
        this.fetchDicts()
      } catch (error) {
        this.$message.error('保存失败')
        console.error(error)
      }
    },

    // 添加字典项
    handleAddItem() {
      this.itemDialogTitle = '添加字典项'
      this.itemForm = {
        dict_code: this.currentDict.code,
        code: '',
        name: '',
        description: '',
        sort_order: 0,
        extra_info: ''
      }
      this.itemDialogVisible = true
    },

    // 编辑字典项
    handleEditItem(row) {
      this.itemDialogTitle = '编辑字典项'
      this.itemForm = { 
        ...row,
        extra_info: row.extra_info ? JSON.stringify(JSON.parse(row.extra_info), null, 2) : ''
      }
      this.itemDialogVisible = true
    },

    // 删除字典项
    async handleDeleteItem(row) {
      try {
        await this.$confirm('确认删除该字典项吗？删除后将无法恢复。', '提示', {
          type: 'warning'
        })
        await axios.delete(`https://aidata.haimoney.com.au/api/dict_item.php?id=${row.id}`)
        this.$message.success('删除成功')
        this.fetchDictItems(this.currentDict.code)
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败')
          console.error(error)
        }
      }
    },

    // 提交字典项表单
    async submitItemForm() {
      try {
        await this.$refs.itemForm.validate()
        const formData = { ...this.itemForm }
        if (formData.extra_info) {
          formData.extra_info = JSON.stringify(JSON.parse(formData.extra_info))
        }
        if (this.itemForm.id) {
          await axios.put('https://aidata.haimoney.com.au/api/dict_item.php', formData)
        } else {
          await axios.post('https://aidata.haimoney.com.au/api/dict_item.php', formData)
        }
        this.$message.success('保存成功')
        this.itemDialogVisible = false
        this.fetchDictItems(this.currentDict.code)
      } catch (error) {
        this.$message.error('保存失败')
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.dict-management {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dict-items-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.extra-info-item {
  margin-bottom: 10px;
  line-height: 1.5;
}

.extra-info-label {
  font-weight: bold;
  margin-right: 10px;
  color: #606266;
}

.extra-info-value {
  color: #303133;
}
</style> 